import FollowCamera, { FollowPhase } from "./follow_camera";
import DioramaCamera from "../../../lib/services/scene/diorama_camera";
import DioramaCameraControl from "../../../lib/services/scene/diorama_camera_control";
import Puppy from "./puppy";
import Frisbee from "../frisbee/frisbee";
import FrisbeeFetchController from "./frisbee_fetch_controller";

export default class FrisbeeFollowCamera extends FollowCamera {
  constructor(
    camera: DioramaCamera,
    camera_control: DioramaCameraControl,
    puppy: Puppy,
    private frisbee: Frisbee,
    private get_fetch_controller: () => FrisbeeFetchController | null
  ) {
    super(camera, camera_control, puppy);
  }

  protected override getPhase(): FollowPhase {
    const fetch = this.get_fetch_controller();
    if (!fetch) return "idle";

    const state = fetch.get_state();

    switch (state) {
      case "planning":
      case "stay_in_place":
      case "chase_object":
      case "chase_disc":
      case "picking_up":
        return "outbound";

      case "returning":
      case "dropping":
        return "returning";

      case "idle":
      default:
        return "idle";
    }
  }

  protected override updateFollowCamera(
    phase: FollowPhase,
    _delta_time: number
  ): void {
    const puppyPos = this.puppy.transform.position;

    if (phase === "outbound") {
      const frisbeePos = this.frisbee.get_world_position();

      const targetX = puppyPos[0] * 0.72 + frisbeePos[0] * 0.28 + 0.25;
      const targetZ = puppyPos[2] * 0.72 + frisbeePos[2] * 0.28 - 0.18;

      this.camera.follow_xz(targetX, targetZ, 0.08);
      this.camera.set_target(
        this.camera.target[0],
        0.60,
        this.camera.target[2]
      );
      this.camera.set_distance(7.2);
      return;
    }

    const returnX = EAT_SPOT[0];
    const returnZ = EAT_SPOT[2];

    const targetX = puppyPos[0] * 0.70 + returnX * 0.30;
    const targetZ = puppyPos[2] * 0.70 + returnZ * 0.30;

    this.camera.follow_xz(targetX, targetZ, 0.08);
    this.camera.set_target(
      this.camera.target[0],
      0.58,
      this.camera.target[2]
    );
    this.camera.set_distance(6.6);
  }
}

const EAT_SPOT = new Float32Array([
  0.5132098197937012,
  0,
  6.010136127471924,
]);